import { appConfig } from "@/config";
import { CameraStreamProvider } from "@/modules/camera-stream";
import { useRelaySession } from "@/modules/device/hooks/useRelaySession";
import { MainLayout } from "@/modules/layout";
import { Spinner } from "@/modules/shadcn/ui/spinner";
import { Navigate, Outlet } from "react-router";
import { useAuth, useAuthInit } from "../../hooks";

export const Authenticated = () => {
  const { isAuthenticated, isPreAuth, organization } = useAuth();
  useAuthInit();

  // Establish the relay cookie as soon as an organization is known, and again
  // whenever it changes. Camera requests are made from all over the app, and
  // three of the transports involved (`<img>`, the dashboard `<iframe>`, the
  // detections WebSocket) cannot retry with a credential, so the cookie has to
  // exist before any of them run rather than be fetched on demand.
  useRelaySession(organization?.id);

  if (isAuthenticated === null) {
    return <Spinner />;
  }

  if (isAuthenticated === false) {
    return <Navigate to={appConfig.web.routes.auth.login} replace={true} />;
  }

  if (isPreAuth) {
    return <Navigate to={appConfig.web.routes.auth.selectOrganization} replace={true} />;
  }

  return (
    <CameraStreamProvider>
      <MainLayout>
        <Outlet />
      </MainLayout>
    </CameraStreamProvider>
  );
};
